import { ROLES } from "@infinitaslearning/module-he-common";
import { StudentOverview } from "layout/StudentOverview";
import { TeacherOverview } from "layout/TeacherOverview";
import { getAccountRole } from "persistence/access";
import type React from "react";

export const Additionals: React.FC = () => {
  const role = getAccountRole();
  return role === ROLES.STUDENT ? <StudentOverview /> : <TeacherOverview />;
};
